import Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsExportData from 'highcharts/modules/export-data'
import HighchartsReact from 'highcharts-react-official';

HighchartsExporting(Highcharts)
HighchartsExportData(Highcharts)

const groupColorMap = {
  'Positive': '#66a839',
  'Neutral': '#f5af00',
  'Negative': '#f75200'
}

// 30% lighter then the base
const preGroupColorMap = {
  'Positive': '#91cc6a',
  'Neutral': '#ffdc85',
  'Negative': '#ffbf72'
}

// const origBaseGroupColorMap = {
//   'Positive': '#66a939',
//   'Neutral': '#f6b000',
//   'Negative': '#f88700'
// } 

// 50% lighter then the base
// const preGroupColorMapNotUsing = {
//   'Positive': '#b1da94',
//   'Neutral': '#ffe6a7',
//   'Negative': '#ffd19a'
// }

const formatChartData = (analyticsData, dataPoints, categories = [], height) => {

  const dataMapper = (counts, targetGroup) => category => {
    const catData = counts[category] || {}
    const { groups = {} } = catData
    const {
      Positive = 0,
      Neutral = 0,
      Negative = 0
    } = groups;
    const targetValue = groups[targetGroup] || 0;
    const percentage = targetValue / (Positive + Neutral + Negative)
    return Number.isNaN(percentage) ? 0 : Math.round( (percentage * 100) * 100) / 100
  }

  const yStackGroups = ['Negative', 'Neutral', 'Positive']

  const dummySeriesForLegend = []
  const mainSeries = [];

  dataPoints.forEach((dataPointObj = {}) => {
    const {
      assessmentName = '',
      label = ''
    } = dataPointObj;

    const displayName = label || assessmentName;

    const assessmentAnalyticsData = analyticsData[assessmentName] || {};
    const { counts = {} } = assessmentAnalyticsData;

    yStackGroups.forEach(yStackGroup => {  
      const seriesName = `${displayName} - ${yStackGroup}`
      const seriesData = categories.map(dataMapper(counts, yStackGroup));

      mainSeries.push({
        name: seriesName,
        data: seriesData,
        stack: displayName,
        color: label === 'PreSurvey' ? preGroupColorMap[yStackGroup]  : groupColorMap[yStackGroup],
        showInLegend: false
      })
    });

    dummySeriesForLegend.push({
      name: displayName,
      type: 'line', // Not rendered, just for legend
      data: [],
      color: label === 'PreSurvey' ? '#91cc6a' : '#66a839',
      // enableMouseTracking: false,
      showInLegend: true,
      customLegendKey: true
    })
  });

  const series = [...mainSeries, ...dummySeriesForLegend]

  return {
    chart: {
        type: 'column',
        backgroundColor: '#fdfdfd',
        height,
        events: {
          load: function () {
            const chart = this;
            chart.legend.allItems.forEach(function (item) {
              if (item.userOptions.customLegendKey) {
                item.update({ events: {
                  legendItemClick: function () {
                    const targetStack = item.name;
                    chart.series.forEach(s => {
                      if (s.userOptions.stack === targetStack) {
                        s.setVisible(!s.visible, false);
                      }
                    });
                    chart.redraw();
                    return false; // Prevent default toggle
                  }
                } });
              }
            });
          }
        }
    },
    title: {
        text: '',
        align: 'left'
    },
    exporting: {
      enabled: false // hides hamburger menu
    },
    xAxis: {
        categories,
        crosshair: true,
        accessibility: {
            description: 'Answers'
        }
    },
    legend: {
      enabled: true,
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const point = this.point;
        const total = point.stackTotal || 0;
        const value = point.y;
        const percentage = total ? ((value / total) * 100).toFixed(0) : '0.0';

        const seriesNameFull = this.series.name || ''
        const splitSeriesName = seriesNameFull.split(' - ')
        const seriesName = splitSeriesName[0] || ''
        const groupName = splitSeriesName[1] || ''
        const groupColor = groupColorMap[groupName]

        // return `<strong>${seriesName} - ${this.x}</strong><br/><strong style="color: ${groupColor};">${groupName}</strong><br/>Total: <b>${value}</b>, Percentage: <b>${percentage}%</b>`;
        return `<strong>${seriesName} - ${this.x}</strong><br/><strong style="color: ${groupColor};">${groupName}</strong><br/>Percentage: <b>${percentage}%</b>`;
      }
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: 'Percentage'
      },
      stackLabels: {
        // enabled: true,
        // style: {
        //   fontWeight: 'bold',
        //   color: 'gray'
        // }
      }
    },

    plotOptions: {
      column: {
        stacking: 'normal',
        grouping: true
      }
    },
    series
  }
}

export default ({
  analyticsData = {},
  dataPoints = [],
  categories = [],
  height,
}) => {
  const options = formatChartData(analyticsData, dataPoints, categories, height)
  return (
    <div>
      <HighchartsReact 
        highcharts={Highcharts} 
        options={options}
      />
    </div>
  )
}